import {
  LLMProvider,
  LLMProviderCreate,
  LLMProviderUpdate,
  LLMProviderDetail,
  LLMUsageStats,
  TestConnectionResponse,
} from "@/types/llm";
import { fetchWithAuth } from "./client";

export const llmApi = {
  listProviders: async (): Promise<LLMProvider[]> => {
    return fetchWithAuth("/api/v1/llm/providers");
  },

  getProvider: async (id: string): Promise<LLMProviderDetail> => {
    return fetchWithAuth(`/api/v1/llm/providers/${id}`);
  },

  createProvider: async (data: LLMProviderCreate): Promise<LLMProvider> => {
    return fetchWithAuth("/api/v1/llm/providers", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },

  updateProvider: async (id: string, data: LLMProviderUpdate): Promise<LLMProvider> => {
    return fetchWithAuth(`/api/v1/llm/providers/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },

  deleteProvider: async (id: string): Promise<void> => {
    await fetchWithAuth(`/api/v1/llm/providers/${id}`, {
      method: "DELETE",
    });
  },

  testConnection: async (id: string): Promise<TestConnectionResponse> => {
    return fetchWithAuth(`/api/v1/llm/providers/${id}/test`, {
      method: "POST",
    });
  },

  setDefault: async (id: string): Promise<LLMProvider> => {
    return fetchWithAuth(`/api/v1/llm/providers/${id}/default`, {
      method: "PUT",
    });
  },

  getUsageStats: async (period?: string): Promise<LLMUsageStats> => {
    let periodDays = 30;
    if (period) {
      const match = period.match(/^(\d+)d$/);
      if (match) {
        periodDays = parseInt(match[1], 10);
      }
    }
    const params = `?period_days=${periodDays}`;
    return fetchWithAuth(`/api/v1/llm/usage${params}`);
  },
};
